// src/components/Projects.jsx
import React from "react";
import DownloadButton from "./DownloadButton";

const ProjectCard = ({ title, description, project }) => {
  return (
    <div className="relative duration-500 transform rotate-3 hover:rotate-0 group border border-yellow-600 border-4 overflow-hidden rounded-2xl h-64 w-80 bg-yellow-400 p-5 flex flex-col items-start gap-4 shadow-xl">
      {/* Title */}
      <div className="text-yellow-900">
        <h3 className="font-bold text-3xl">{title}</h3>
        <p className="text-xs mt-1">{description}</p>
      </div>

      {/* Download Button */}
      <DownloadButton project={project} />

      {/* Background SVGs */}
      <svg
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
        className="group-hover:scale-125 duration-500 absolute -bottom-0.5 -right-20 w-48 h-48 z-10 -my-2 fill-yellow-100 stroke-yellow-700"
      >
        <path
          strokeWidth={5}
          strokeMiterlimit={10}
          d="M 50.4 51 C 40.5 49.1 40 46 40 44 v -1.2 a 18.9 18.9 0 0 0 5.7 -8.8 h 0.1 c 3 0 3.8 -6.3 3.8 -7.3 s 0.1 -4.7 -3 -4.7 C 53 4 30 0 22.3 6 c -5.4 0 -5.9 8 -3.9 16 c -3.1 0 -3 3.8 -3 4.7 s 0.7 7.3 3.8 7.3 c 1 3.6 2.3 6.9 4.7 9 v 1.2 c 0 2 0.5 5 -9.5 6.8 S 2 62 2 62 h 60 a 14.6 14.6 0 0 0 -11.6 -11 z"
        />
      </svg>
    </div>
  );
};

const Projects = () => {
  const projects = [
    {
      title: "PDF to Word Converter",
      description: "Convert PDF files to Word format with ease.",
      project: "1",
    },
    {
      title: "Sinhglish to Sinhala Converter",
      description: "Convert Romanized Sinhala to Sinhala script.",
      project: "2",
    },
    {
      title: "Finance Tracker",
      description: "Track income and expenses with full CRUD support.",
      project: "3",
    },
    {
      title: "Game Cafe Timer",
      description: `An Electron-based app to manage and track gaming sessions in a gaming cafe. It allows you to create timers for individual PCs, calculate costs based on hourly rates, and view daily and monthly summaries. Built with HTML, CSS, and JavaScript using Electron for cross-platform desktop support.`,
      project: "4",
    },
    {
      title: "VCU Calculator chrome extension",
      description: `A React-based chrome extension featuring three interactive calculators for financial planning.`,
      project: "5",
    },
  ];

  return (
    <section
      className="py-20 px-4 bg-gradient-to-b from-gray-900 to-black"
      id="projects"
    >
      <div className="container mx-auto">
        <h2 className="text-6xl font-bold text-center text-yellow-400 mb-12">
          Projects
        </h2>
        <br />
        <div className="flex flex-wrap justify-center gap-24">
          {projects.map((project, index) => (
            <ProjectCard
              key={index}
              title={project.title}
              description={project.description}
              project={project.project}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
